export const ListQueryKey = 'users';
export const DetailQueryKey = 'user';
export const Urls = {
  selectUrl: '/account/list',
  updateUrl: '/account/update',
  deleteUrl: '/account/delete',
  createUrl: '/account/create',
  detailUrl: '',
  balanceUrl: '/account/balance'
};